import type { ReactNode } from 'react'
import { IconButton } from '@/components/IconButton'
import {
  EditorListItem,
  EditorListItemActions,
} from '@/features/legends/components/EditorList'
import styles from './RoutingDataSource.module.css'

export interface RoutingDataSourceProps {
  /**
   * The source's fields.
   */
  children?: ReactNode
  onRemove: () => unknown
  isDisabled?: boolean
  /**
   * The remove button gets `${testId}-remove-button`.
   */
  testId?: string
}

/**
 * A routing data source, edited in place in the list of sources.
 */
export function RoutingDataSource({
  children,
  onRemove,
  isDisabled,
  testId,
}: RoutingDataSourceProps) {
  return (
    <EditorListItem testId={testId}>
      <div className={styles.root}>{children}</div>
      {!isDisabled && (
        <EditorListItemActions>
          <IconButton
            name="close"
            label="Remove data source"
            size={14}
            onPress={onRemove}
            testId={testId && `${testId}-remove-button`}
          />
        </EditorListItemActions>
      )}
    </EditorListItem>
  )
}
